export default __webpack_public_path__ + "static/Premio-home-6797e3787dcb3a0b975145236131cbd8.png";